module.exports = __webpack_public_path__ + "img/rjcCertifiedMember@2x.0578b2c.jpg";